import { USER_ACCESS_LEVEL } from '@/utils/constants';
import { nearExpirationRegos } from '@/store/lease/getters';
import { hasStartedApplication } from '@/store/application/getters';

export function hasLeasesOrCompleteApplication({ lease }, getters) {
  return (
    (getters['application/applicationComplete'] &&
      getters['settlement/hasSettlementCompleted']) ||
    lease.hasLeases
  );
}

export function canCreateQuote({ user, application, lease }, getters) {
  // Credit only users can not create any applications
  if (getters['user/userIsAccessLevel']([USER_ACCESS_LEVEL.CREDIT_ONLY])) {
    return false;
  }

  const quoteId = getters['application/acceptedQuoteId'];
  const loading =
    user.loadingUser ||
    application.applicationLoading ||
    (!application.applicationId && lease.leasesLoading);
  return !loading && !quoteId;
}

export function allowEndOfLifeQuote({ application, lease }) {
  return (
    !hasStartedApplication(application) && !!nearExpirationRegos(lease).length
  );
}
